import React, { useEffect } from 'react';

import { Routes, Route, useLocation } from 'react-router-dom';
import { store as toastStore } from 'react-semantic-toasts/build/toast';

import { Login } from '../features/auth/Login';
import { Signup } from '../features/auth/Signup';
import { Products } from '../features/Products/list/ProductsList';
import { ProductCreate } from '../features/Products/create/ProductCreate';
import { EditProduct } from '../features/Products/edit/ProductEdit';
import { Users } from '../features/User/list/UserList';
import { CreateUser } from '../features/User/create/UserCreate';
import { Distributors } from '../features/Distributors/list/DistributorsList';
import { CreateDistributor } from '../features/Distributors/create/DistributorCreate';
import { ServiceTypes } from '../features/ServiceTypes/list/ServiceTypeList';
import { CreateServiceType } from '../features/ServiceTypes/create/ServiceTypeCreate';
import { Header } from '../features/Header/Header';
import { NavBar } from '../features/NavBar/NavBar';
import { useAuth } from '../providers/AuthenticationProvider';
import { Dashboard } from '../features/Dashboard/Dashboard';
import { ProposalList } from '../features/Proposal/list/ProposalList';
import { ProposalCreate } from '../features/Proposal/create/ProposalCreate';
import { CustomerList } from '../features/Customer/list/CustomerList';
import { CustomerCreate } from '../features/Customer/create/CustomerCreate';
import { ProposalEdit } from '../features/Proposal/edit/ProposalEdit';
import { ProposalView } from '../features/Proposal/view/ProposalView';
import { CustomerEdit } from '../features/Customer/edit/CustomerEdit';
import {Settings} from '../features/Settings/Settings';
import { ChangePassword } from '../features/User/changePassword/changePassword';
import { ForgotPassword } from '../features/auth/ForgotPassword';
import { ReportCreate } from '../features/Report/create/ReportCreate';
import { ReportList } from '../features/Report/list/ReportList';
import { DataInspector } from '../features/DataInspector/DataInspector';
import { SiteHealth } from '../features/SiteHealth/SiteHealth';
import { DataMaintenance } from '../features/DataMaintenance/DataMaintenance';
import { UtilityAccounts } from '../features/UtilityAccounts/UtilityAccounts';
import { UnitConversions } from '../features/UnitConversions/UnitConversions';
import { UtilityMeters } from '../features/UtilityMeters/UtilityMeters';
import {ReportTemplates} from "../features/Report/templates/ReportTemplates";
// import {ComponentTree} from "../features/ComponentTree/ComponentTree";
import { PointMapping } from "../features/PointMapping/PointMapping";
import { ConnectorPointMapping } from "../features/ConnectorPointMapping";
import { ConnectorAdmin } from "../features/ConnectorAdmin";
import { EquipmentList } from "../features/Equipment/list/EquipmentList";
import { EquipmentReport } from "../features/Equipment/report/EquipmentReport";
import { EquipmentDashboard } from "../features/Equipment/dashboard/EquipmentDashboard";
import { GenericPoints } from '../features/GenericPoints/GenericPoints';
import { EquipmentEdit } from "../features/Equipment/edit/EquipmentEdit";
import { GroupReport } from "../features/GroupReport/GroupReport";
import { WeatherStationsList } from "../features/WeatherStations/list/WeatherStationsList";
import {WeatherStationCreate} from "../features/WeatherStations/create/WeatherStationCreate";
import {WeatherStationEdit} from "../features/WeatherStations/edit/WeatherStationEdit";
import { IssueOptions } from '../features/IssueOptions/IssueOptions';
import { TaskOptions } from '../features/TaskOptions/TaskOptions';
import { ComponentManager } from "../features/ComponentManager/ComponentManager";

export const AppRoutes = () => {
    const { isLoggedIn, isSystemAdmin, isPathianTech } = useAuth();
    const { pathname } = useLocation();
    const isProposalViewRoute = pathname.includes('/proposals/view/');

    useEffect(() => {
        [...toastStore.data].forEach(item => toastStore.remove(item));
    }, [pathname]);
    return (
        <>
            {isLoggedIn && !isProposalViewRoute ? (
                <>
                    <Header />
                    <NavBar />
                </>
            ) : null}
            <div style={isLoggedIn && !isProposalViewRoute ? { position: 'fixed', top: 'var(--header-height)', left: 'var(--sidebar-width)', right: 0, bottom: 0, padding: '25px 55px 55px', overflowY: 'auto', boxSizing: 'border-box', scrollbarGutter: 'stable' } : {}}>
                <Routes>
                    {/* authenticated routes */}
                    {isLoggedIn ? <Route end path="/products" element={<Products />} /> : null}
                    {isLoggedIn ? <Route end path="/products/create-product" element={<ProductCreate />} /> : null}
                    {isLoggedIn ? <Route end path="/products/:id" element={<EditProduct />} /> : null}
                    {isLoggedIn ? <Route end path="/product-types/create-product-type" element={<CreateServiceType />} /> : null}
                    {isLoggedIn ? <Route end path="/users" element={<Users />} /> : null}
                    {isLoggedIn ? <Route end path="/proposals" element={<ProposalList />} /> : null}
                    {isLoggedIn ? <Route end path="/proposals/create/" element={<ProposalCreate />} /> : null}
                    {isLoggedIn ? <Route end path="/proposals/edit/:id" element={<ProposalEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/proposals/view/:viewToken" element={<ProposalView />} /> : null}
                    {isLoggedIn ? <Route end path="/users/create-user" element={<CreateUser />} /> : null}
                    {isLoggedIn ? <Route end path="/users/edit" element={<CreateUser />} /> : null}
                    {isLoggedIn ? <Route end path="/customers" element={<CustomerList />} /> : null}
                    {isLoggedIn ? <Route end path="/customers/create-customer" element={<CustomerCreate />} /> : null}
                    {isLoggedIn ? <Route end path="/customers/edit/:id" element={<CustomerEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/distributors" element={<Distributors />} /> : null}
                    {isLoggedIn ? <Route end path="/distributors/create-distributor" element={<CreateDistributor />} /> : null}
                    {isLoggedIn ? <Route end path="/distributors/edit" element={<CreateDistributor />} /> : null}
                    {isLoggedIn ? <Route end path="/distributors/settings" element={<Settings />} /> : null}
                    {isLoggedIn ? <Route end path="/service-types" element={<ServiceTypes />} /> : null}
                    {isLoggedIn ? <Route end path="/dashboard" element={<Dashboard />} /> : null}
                    {isLoggedIn ? <Route end path="/*" element={<ReportList />} /> : null}
                    {isLoggedIn ? <Route end path="/users/change-password" element={<ChangePassword />} /> : null}
                    {isLoggedIn ? <Route end path="/reports/create" element={<ReportCreate />} /> : null}
                    {isLoggedIn ? <Route end path="/reports/templates" element={<ReportTemplates />} /> : null}
                    {isLoggedIn ? <Route end path="/reports" element={<ReportList />} /> : null}
                    {isLoggedIn ? <Route end path="/datainspector" element={<DataInspector />} /> : null}
                    {isLoggedIn ? <Route end path="/sitehealth" element={<SiteHealth />} /> : null}
                    {isLoggedIn ? <Route end path="/data-maintenance" element={<DataMaintenance />} /> : null}
                    {isLoggedIn ? <Route end path="/utilityaccounts" element={<UtilityAccounts />} /> : null}
                    {isLoggedIn ? <Route path="/utility-account/:utilityAccountId/utility-meters" element={<UtilityMeters />} /> : null}
                    {isLoggedIn && (isSystemAdmin() || isPathianTech()) ? <Route end path="/unit-conversions" element={<UnitConversions />} /> : null}
                    {/* {isLoggedIn ? <Route end path="/component-tree" element={ComponentTree} /> : null} */}
                    {isLoggedIn ? <Route end path="/component-manager" element={<ComponentManager />} /> : null}
                    {isLoggedIn ? <Route end path="/point-mapping" element={<PointMapping />} /> : null}
                    {isLoggedIn ? <Route end path="/connector-mapping" element={<ConnectorPointMapping />} /> : null}
                    {isLoggedIn ? <Route end path="/connector-admin" element={<ConnectorAdmin />} /> : null}
                    {isLoggedIn ? <Route end path="/equipment" element={<EquipmentList />} /> : null}
                    {isLoggedIn ? <Route end path="/equipment/:id/report" element={<EquipmentReport />} /> : null}
                    {isLoggedIn ? <Route end path="/equipment/:id/dashboard" element={<EquipmentDashboard />} /> : null}
                    {isLoggedIn ? <Route end path="/equipment/create" element={<EquipmentEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/building/create" element={<EquipmentEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/space/create" element={<EquipmentEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/reports/group" element={<GroupReport />} /> : null}
                    {isLoggedIn ? <Route end path="/generic-points" element={<GenericPoints />} /> : null}
                    {isLoggedIn ? <Route end path="/equipment/:id" element={<EquipmentEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/building/:id" element={<EquipmentEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/space/:id" element={<EquipmentEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/weather-stations" element={<WeatherStationsList />} /> : null}
                    {isLoggedIn ? <Route end path="/weather-stations/create" element={<WeatherStationCreate />} /> : null }
                    {isLoggedIn ? <Route end path="/weather-stations/edit/:id" element={<WeatherStationEdit />} /> : null}
                    {isLoggedIn ? <Route end path="/issue-options" element={<IssueOptions />} /> : null}
                    {isLoggedIn ? <Route end path="/task-options" element={<TaskOptions />} /> : null}

                    {/* unauthenticated routes */}
                    {!isLoggedIn ? <Route end path="/proposals/view/:viewToken" element={<ProposalView />} /> : null}
                    {!isLoggedIn ? <Route end path="/forgot-password" element={<ForgotPassword />} /> : null}
                    {!isLoggedIn ? <Route end path="/signup" element={<Signup />} /> : null}
                    {!isLoggedIn ? <Route end path="/*" element={<Login />} /> : null }
                </Routes>
            </div>
        </>
    );
};
